<div class="content-block">
  <h1 class="panel-title">This application has been deleted.</h1>
  <div class="margin-top">
    If you believe this is an error, <a href="/{{ accountId }}/support">please contact support.</a>
  </div>
</div>
